import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputArticleAttachmentAdd } from './InputArticleAttachmentAdd.entity';
import { InputArticleAttachmentModify } from './InputArticleAttachmentModify.entity';

export class InputArticleAttachment<T extends EMode = EMode.entity> {
  /** Alias: delete */
  delete?: number[];
  /** Alias: add */
  add?: InputArticleAttachmentAdd<T>[];
  /** Alias: modify */
  modify?: InputArticleAttachmentModify<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputArticleAttachment> = {
  delete: {
    alias: 'delete',
  },
  add: {
    alias: 'add',
  },
  modify: {
    alias: 'modify',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputArticleAttachmentEntityDefinition: EntitiyDefinition<InputArticleAttachment> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputArticleAttachment',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
